module.exports = __webpack_public_path__ + "img/E_talk.3a8c51f6.gif";